import { render, staticRenderFns } from "./postConfigHr.vue?vue&type=template&id=f2f0c5d4&"
import script from "./postConfigHr.vue?vue&type=script&lang=js&"
export * from "./postConfigHr.vue?vue&type=script&lang=js&"
import style0 from "./postConfigHr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postConfigHr.vue"
export default component.exports